module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/documents/documents/documents.component.css
// module id = ./src/app/pages/documents/documents/documents.component.css
// module chunks = main